import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {useFeatureFlagStore} from '../../stores/featureFlagStore';

export async function userAdministrationGuard(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const featureEnabled = await useFeatureFlagStore().newUserAdministration.isReady();

    if (featureEnabled && to.name === 'AdminUsersDeprecated') {
        return {name: 'AdminUserList', params: to.params};
    }

    if (!featureEnabled && to.name === 'AdminUserList') {
        return {name: 'AdminUsersDeprecated', params: to.params};
    }

    // Allow all other routes (AdminUserAdd, AdminUserEdit, etc.) to proceed normally
}
